<div class="embargo-management-grid-container">
  <nz-table
    #rowSelectionTable
    nzShowPagination
    [nzFrontPagination]="false"
    [nzData]="gridData"
    [nzLoading]="loading"
    [(nzScroll)]="gridSize"
    nzSize="middle"
    [(nzPageIndex)]="pageIndex"
    [(nzPageSize)]="pageLimit"
    (nzPageIndexChange)="onPaginationChange()"
    [nzWidthConfig]="widthConfig"
    [nzTotal]="total"
    (mouseleave)="hoverIndex = null"
  >
    <thead>
      <tr>
        <th
          class="ant-table-column-title"
        >
          Select
        </th>
        <th
        [nzSortFn]="undefined"
          class="ant-table-column-title"
        >
          Broker
        </th>
        <th
          [nzSortFn]="undefined"
          class="ant-table-column-title"
        >
          Buy-side
        </th>
        <th class="ant-table-column-title">Model Data Usage Embargo (days)</th>
        <th class="ant-table-column-title">Model Download Embargo (days)</th>
        <th class="ant-table-column-title">Research Download Embargo (days)</th>
      </tr>
      <tr *ngIf="isFilterEnable">
        <th class="ant-table-second-row-header"></th>
        <th class="ant-table-second-row-header">
          <div class="input-search-holder">
            <input
              type="text"
              nz-input
              class="input-search"
              [(ngModel)]="brokerKeyword"
              placeholder="Search Broker"
              (keyup.enter)="search()"
            />
            <span class="text-filter-clear" (click)="reset('broker')">
              <va-icon size="small" name="close"></va-icon>
            </span>
          </div>
        </th>
        <th class="ant-table-second-row-header">
          <div class="input-search-holder">
            <input
              type="text"
              nz-input
              class="input-search"
              [(ngModel)]="buysideKeyword"
              placeholder="Search Buyside"
              (keyup.enter)="search()"
            />
            <span class="text-filter-clear" (click)="reset('buyside')">
              <va-icon size="small" name="close"></va-icon>
            </span>
          </div>
        </th>
        <th class="ant-table-second-row-header"></th>
        <th class="ant-table-second-row-header"></th>
        <th class="ant-table-second-row-header"></th>
      </tr>
    </thead>
    <tbody>
      <tr
        *ngFor="let data of rowSelectionTable.data; let index = index"
        (mouseover)="hoverIndex = index"
      >
        <td
          class="ant-table-row-data"
          nzShowCheckbox="true"
          [nzChecked]="checked"
          (nzCheckedChange)="deleteCheckboxClicked($event, data)"
        ></td>
        <td class="ant-table-row-data row-data-width-250">
          <span nz-tooltip nzTooltipTitle="{{ data.broker }}">{{
            data.broker
          }}</span>
        </td>
        <td class="ant-table-row-data row-data-width-250">
          <span nz-tooltip nzTooltipTitle="{{ data.buyside }}">{{
            data.buyside
          }}</span>
        </td>
        <td class="ant-table-row-data">{{ data.modelData }}</td>
        <td class="ant-table-row-data">{{ data.modelDownload }}</td>
        <td class="ant-table-row-data">
          {{ data.researchDownload }}
          <div class="action-button-container" *ngIf="hoverIndex === index">
            <span
              nz-tooltip
              nzTooltipTitle="Edit"
              (click)="editEmbargoOverride(data)"
            >
              <va-icon isFontAwesome="true" [name]="faEdit" class="fa-lg"></va-icon>
            </span>
            <span
              nz-tooltip
              nzTooltipTitle="History"
              class="button-separator"
              (click)="showEmbargoHistory(data)"
            >
              <va-icon isFontAwesome="true" [name]="faHistory" class="fa-lg"></va-icon>
            </span>
          </div>
        </td>
      </tr>
    </tbody>
  </nz-table>
</div>

<!-- Embargo History Modal -->
<div class="embargo-history-modal-container">
  <app-history-modal
    [showModal]="isEmbargoHistoryVisible"
    (closeModal)="closeModalEmbargoHistory($event)"
    [gridColumnList]="embargoHistoryGridColumnList"
    [gridColumnFields]="embargoHistoryGridColumnFields"
    [gridData]="embargoHistoryGridData"
    [total]="totalHistoryData"
    [modalTitle]="embargoHistoryTitle"
    [widthConfig]="embargoHistoryWidthConfig"
    (pageDetailsChangeHandler)="onPageDetailsChange($event[0], $event[1])"
  >
  </app-history-modal>
</div>
